import { createContext, useContext } from "react";

export const BuilderCtx = createContext(null);
export const useBuilder = () => useContext(BuilderCtx);
